
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Ref,
  Watch,
} from "vue-property-decorator";
import { isFromDateBeforeToDate } from "@/validation/Common/Dates/DateValidation";
import DatePickerInMenu from "@/components/Base/Inputs/Dates/DatePickerInMenu.vue";

@Component({ components: { DatePickerInMenu } })
export default class DateRangeCustom extends Vue {
  @PropSync("fromDate", { type: String })
  fromDateSync!: string;

  @PropSync("toDate", { type: String })
  toDateSync!: string;

  @Prop({ required: false })
  label!: string;

  @Ref()
  fromDatePicker!: DatePickerInMenu;

  @Ref()
  toDatePicker!: DatePickerInMenu;

  fromDateErrors = [] as string[];
  toDateErrors = [] as string[];

  @Watch("fromDateSync")
  fromDatePickerDateChanged(): void {
    this.validate();
  }

  @Watch("toDateSync")
  toDatePickerDateChanged(): void {
    this.validate();
  }

  private validate(): boolean {
    this.fromDateErrors = [];
    this.toDateErrors = [];

    if (!isFromDateBeforeToDate(this.fromDateSync, this.toDateSync)) {
      const errorMessage = "From Date must be before To Date";
      this.fromDateErrors.push(errorMessage);
      this.toDateErrors.push(errorMessage);

      return false;
    }

    return true;
  }

  public isValid(): boolean {
    return this.fromDatePicker.isValid() && this.toDatePicker.isValid();
  }
}
